import React from 'react';

import getCommonStack, { CommonStackParamList } from '@navigation/CommonStack';
import { HomeRoute } from '@navigation/Routes';
import { createStackNavigator } from '@react-navigation/stack';
import HomeScreen from '@screens/Home';

export type HomeStackParamList = {
  [HomeRoute.Home]: {
    reload?: boolean;
  };
} & CommonStackParamList;

const HomeStackNavigator = createStackNavigator<HomeStackParamList>();

export default function HomeStack() {
  return (
    <HomeStackNavigator.Navigator
      id={undefined}
      initialRouteName={HomeRoute.Home}
      screenOptions={{
        headerShown: true,
        headerBackButtonDisplayMode: 'generic',
      }}>
      <HomeStackNavigator.Screen
        name={HomeRoute.Home}
        component={HomeScreen}
        options={{ title: 'Joinstar' }}
      />
      {getCommonStack(HomeStackNavigator)}
    </HomeStackNavigator.Navigator>
  );
}
